export default __webpack_public_path__ + "static/media/stepper-two.e859fc3e.png";